export default "__VITE_ASSET__OKLw5hnn__"